import * as React from "react";
import styled from "../../styled";
import { Modal } from "../layout/modal";
import { OrderModalHeader } from "./modal-header";
import { ModalFieldLabel } from "./status-button-grid";
const Body = styled("div") `
	padding: 16px;
	display: flex;
	flex-direction: column;
`;
const List = styled("div") `
	display: flex;
	flex-direction: column;
	gap: 12px;
`;
const PrinterBtn = styled("button") `
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	padding: 8px 12px;
	border: 1px solid #d5d7da;
	border-radius: 8px;
	background: #f1f4f7;
	color: #414651;
	font-family: inherit;
	font-size: 14px;
	font-weight: 600;
	line-height: 20px;
	cursor: pointer;
	box-shadow: 0 1px 2px rgba(10, 13, 18, 0.05);
	&:hover {
		background: #e8eaed;
	}
`;
/** Stacked "Select Printer" modal shared by the admin order + booking modals. */
export const PrinterPickModal = (props) => {
    const { active, close, title, badge, printers, onPick } = props;
    return (React.createElement(Modal, { width: 360, level: 2, alignTop: true, closeButton: false, active: active, close: close },
        React.createElement(OrderModalHeader, { title: title, badge: badge, onBack: close, onClose: close }),
        React.createElement(Body, null,
            React.createElement(ModalFieldLabel, null, "Select Printer"),
            React.createElement(List, null, printers.map((p) => (React.createElement(PrinterBtn, { key: p._id, type: "button", onClick: () => onPick(p._id) },
                React.createElement("span", { className: "notranslate" }, p.name))))))));
};
//# sourceMappingURL=printer-pick-modal.js.map